




























import { defineComponent, ref, useFetch } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { useConfig } from '~/composables';
import { getTagColor } from '~/utils/solepro/products';
import { MenuProductBox } from '~/utils/types/Product';
import { getProductTypeTag } from '~/utils/solepro/products';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';

export default defineComponent({
    props: {
        product: {
            type: Object as PropType<MenuProductBox>,
            required: true
        },
        customTag:{
            type: String,
            required: false
        }
    },
    setup(props) {
        const {config}= useConfig();
        const allCategories = ref([]);
        const categoryStore = useCategoryStore();
        const productTypeTag = ref('')
        useFetch(async()=>{
            categoryStore.load();
            allCategories.value = categoryStore.rawCategories?.items[0].children;
            productTypeTag.value = getProductTypeTag(allCategories.value, props.product)?.name

        })
        return{
            productTypeTag,
            storeCode: config.value.store_code
        }
    },
    methods: {
        getColor(rgbaColor){
            return getTagColor(rgbaColor)
        }
    }
})
